// extracted by mini-css-extract-plugin
export default {"trigger":"Tooltip_trigger__2Pmh2","tooltip":"Tooltip_tooltip__WZgx+","inner":"Tooltip_inner__VbxzZ","arrow":"Tooltip_arrow__LkB3W","darkColor":"Tooltip_darkColor__L1mNd"};